import React from "react";
import { Form, Col, Container, Row } from "react-bootstrap";
import PostcodeInput from "../Common/PostcodeInput";

const InformationHistoryFilters = ({ onFilterChange, onSearch, filters = {} }) => {
  return (
    <Container className="mt-4">
      <Form onKeyDown={(e) => { if (e.key === 'Enter' && !['TEXTAREA', 'SELECT'].includes(e.target.tagName)) { e.preventDefault(); onSearch?.(); } }}>
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="dateFrom">
              <Form.Label>Data od</Form.Label>
              <Form.Control
                type="date"
                value={filters.dateFrom || ""}
                onChange={(e) => onFilterChange("dateFrom", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="dateTo">
              <Form.Label>Data do</Form.Label>
              <Form.Control
                type="date"
                value={filters.dateTo || ""}
                onChange={(e) => onFilterChange("dateTo", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="cityName">
              <Form.Label>Miejscowość</Form.Label>
              <Form.Control
                type="text"
                placeholder="Miejscowość..."
                value={filters.cityName || ""}
                onChange={(e) => onFilterChange("cityName", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="postcode">
              <Form.Label>Kod pocztowy</Form.Label>
              <PostcodeInput
                value={filters.postcode || ""}
                onChange={(val) => onFilterChange("postcode", val)}
                  inputMode="numeric"
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="street">
              <Form.Label>Ulica</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ulica..."
                value={filters.street || ""}
                onChange={(e) => onFilterChange("street", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="terminalDr">
              <Form.Label>Terminal DR</Form.Label>
              <Form.Control
                type="text"
                placeholder="Terminal DR..."
                value={filters.terminalDr || ""}
                onChange={(e) => onFilterChange("terminalDr", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="terminalEx">
              <Form.Label>Terminal EX</Form.Label>
              <Form.Control
                type="text"
                placeholder="Terminal EX..."
                value={filters.terminalEx || ""}
                onChange={(e) => onFilterChange("terminalEx", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default InformationHistoryFilters;
